import { useState } from "react";
import { useTranslation } from "react-i18next";

import { getDocumentStreamUrl } from "@/api/rest/services/documentService";

/**
 * Plays a chat attachment in place. A video the browser can't show (AVI, MPEG, HEVC on some PCs) removes the player
 * and leaves the message's download button.
 */
export default function ChatVideo({ hash, mimeType }: { hash: string; mimeType?: string | null }) {
  const { t } = useTranslation();
  const [unplayable, setUnplayable] = useState(false);

  if (!mimeType?.startsWith("video/") || unplayable) {
    return null;
  }

  return (
    <video
      // The time makes iOS Safari show the first frame instead of an empty player.
      src={`${getDocumentStreamUrl(hash)}#t=0.001`}
      aria-label={t("chat.videoAttachment")}
      className="max-w-[300px] max-h-[300px] md:max-w-[40vw] md:max-h-[40vh] m-0 rounded bg-black"
      controls
      playsInline
      preload="metadata"
      onError={() => setUnplayable(true)}
      // Browsers can decode the sound of a video whose picture they can't show.
      onLoadedMetadata={(event) => setUnplayable(event.currentTarget.videoWidth === 0)}
    />
  );
}
